import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import InitialFilters from "./FormFilters";
import DriverPerformanceHistoric from "./index";
const styles = () => ({
  wrapper: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

class DriverPerformanceFormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: null,
    };
  }

  renderReport = (reportType, selectedFilterData) => {
    this.setState({
      reportType,
      selectedFilterData,
    });
  };

  goBack = () => {
    this.setState({
      reportType: null,
    });
  };

  render() {
    const { reportType } = this.state;
    return (
      <>
        {!reportType && (
          <InitialFilters
            handleDropdownChange={this.handleDropdownChange}
            renderReport={this.renderReport}
          />
        )}
        {reportType && (
          <DriverPerformanceHistoric
            selectedFilterData={this.state.selectedFilterData}
            reportType={reportType}
            goBack={this.goBack}
          />
        )}
      </>
    );
  }
}
export default compose(withStyles(styles))(DriverPerformanceFormPage);
